var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrdersJob(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26112_43057)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F1F1F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8159 11.5335C23.4108 11.1901 22.8957 11 22.3613 11H15.5174L15.4299 11.005C15.0569 11.0484 14.7674 11.3654 14.7674 11.75C14.7674 12.1642 15.1032 12.5 15.5174 12.5H22.3613L22.4584 12.5063C22.6186 12.5272 22.7687 12.5995 22.8855 12.7137L25.7968 15.5594L25.8637 15.6341C25.966 15.7652 26.0226 15.9275 26.0226 16.0957V25.9645L26.0276 26.052C26.0709 26.425 26.3879 26.7145 26.7726 26.7145C27.1868 26.7145 27.5226 26.3787 27.5226 25.9645V16.0957L27.5175 15.945C27.4806 15.3945 27.2423 14.8748 26.8453 14.4867L23.934 11.641L23.8159 11.5335ZM12.5 14.9577C12.5 14.4197 12.9361 13.9836 13.4741 13.9836H21.1923C21.3913 13.9836 21.5822 14.0627 21.7229 14.2036L24.2806 16.764C24.4211 16.9046 24.5 17.0953 24.5 17.294V28.0095C24.5 28.5475 24.0639 28.9836 23.5259 28.9836H13.4741C12.9361 28.9836 12.5 28.5475 12.5 28.0095V14.9577ZM14.9 18.425H22.0229C22.3153 18.425 22.5523 18.1732 22.5523 17.8625C22.5523 17.5519 22.3153 17.3 22.0229 17.3H14.9C14.6076 17.3 14.3706 17.5519 14.3706 17.8625C14.3706 18.1732 14.6076 18.425 14.9 18.425ZM22.0697 21.9641H14.9469C14.6545 21.9641 14.4175 21.7122 14.4175 21.4016C14.4175 21.0909 14.6545 20.8391 14.9469 20.8391H22.0697C22.3621 20.8391 22.5992 21.0909 22.5992 21.4016C22.5992 21.7122 22.3621 21.9641 22.0697 21.9641ZM14.9469 25.5102H19.5069C19.7993 25.5102 20.0363 25.2584 20.0363 24.9477C20.0363 24.637 19.7993 24.3852 19.5069 24.3852H14.9469C14.6545 24.3852 14.4175 24.637 14.4175 24.9477C14.4175 25.2584 14.6545 25.5102 14.9469 25.5102Z",
    fill: "#4251DA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26112_43057"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdersJob);
export default __webpack_public_path__ + "static/media/orders-job.920142d0357529bbf76c24353f9b07ec.svg";
export { ForwardRef as ReactComponent };